__turbopack_context__.v({
  "className": "roboto_mono_37c6608e-module__tQs25a__className",
  "variable": "roboto_mono_37c6608e-module__tQs25a__variable",
});
